import { render, staticRenderFns } from "./OrderBumpCard.vue?vue&type=template&id=61590fd4"
import script from "./OrderBumpCard.vue?vue&type=script&lang=js"
export * from "./OrderBumpCard.vue?vue&type=script&lang=js"
import style0 from "./OrderBumpCard.vue?vue&type=style&index=0&id=61590fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports